import { Checkall } from "./checkall"

type MultiselectOptions = {
    previewMaxItems: number,
    searchMinItems: number,
}

type SearchElement = [HTMLElement, string];

class Multiselect {
    elContainer: HTMLElement;
    elPreview:   HTMLElement;
    elMenu:      HTMLElement;
    elSearch:    HTMLInputElement;

    checkAll: Checkall;

    previewMaxItems: number;
    searchMinItems: number;

    searchElements: Array<SearchElement> = [];
    searchResults: Array<number> = [];
    searchString: string = "";

    cursor: number = null;

    constructor(container: Element, opts: Partial<MultiselectOptions> = {}) {
        this.elContainer  = container as HTMLInputElement;
        this.elPreview    = container.querySelector('.multiselect-preview');
        this.elMenu       = container.querySelector('.multiselect-menu');

        this.previewMaxItems = opts.previewMaxItems || 3;
        this.searchMinItems = opts.searchMinItems || 0;

        this.init();
    }

    init() {
        this.elPreview.addEventListener('click', (e) => {
            this.toggleMenu();
        });

        this.elSearch  = this.elMenu.querySelector("input.multiselect-item-search") as HTMLInputElement;
        let checkAll   = this.elMenu.querySelector(".multiselect-item-checkall");
        let checkboxes = this.elMenu.querySelectorAll('.multiselect-item-checkbox');

        if (checkAll) {
            this.checkAll = new Checkall(checkAll as HTMLInputElement, checkboxes as NodeListOf<HTMLInputElement>, {
                afterChange: (changed: Array<HTMLInputElement>) => {
                    this.refreshPreview();
                },
            })
        }

        if (this.elSearch) {

            this.searchResults = [];

            this.elMenu.querySelectorAll('.multiselect-item').forEach((el: HTMLElement) => {
                this.searchResults.push(this.searchResults.length);
                this.searchElements.push([el, el.querySelector(".multiselect-item-label").textContent.toLowerCase()]);
            });

            this.elSearch.addEventListener("input", (e) => {

                const oldSearchString = this.searchString;
                const newSearchString = this.elSearch.value.toLowerCase();

                const isPrefix = newSearchString.startsWith(oldSearchString);

                this.searchString = newSearchString;

                let newSearchResults: Array<number> = [];
                let toShow = new Set<HTMLElement>();
                let toHide = new Set<HTMLElement>();

                if (!isPrefix) {
                    // First reset to all results, then filter
                    this.searchResults = [];
                    this.searchElements.forEach((se, i) => {
                        this.searchResults.push(i);
                        if (se[0].classList.contains("hide")) {
                            toShow.add(se[0])
                        }
                    });
                }

                this.searchResults.forEach((i) => {
                    const se = this.searchElements[i];

                    if (se[1].search(newSearchString) !== -1) {
                        // found
                        newSearchResults.push(i);
                    } else {
                        // not found
                        toHide.add(se[0]);
                        toShow.delete(se[0]);
                    }
                })

                toShow.forEach((el) => {
                    el.classList.remove("hide");
                })
                toHide.forEach((el) => {
                    el.classList.add("hide");
                })
                
                this.searchResults = newSearchResults;
            })
        }

        checkboxes.forEach((el) => {
            el.addEventListener('change', (e) => {
                this.refreshPreview();
            })
        })

        this.refreshPreview();
    }

    refreshPreview() {
        let selected: Array<HTMLElement> = [];

        let total = 0;

        this.elMenu.querySelectorAll('.multiselect-item-checkbox').forEach((el: HTMLInputElement) => {
            if (el.checked) {
                selected.push(el.parentElement.querySelector(".multiselect-item-label"))
            }
            total++;
        })

        let preview = this.elPreview.getAttribute('data-label-empty');

        if (selected.length > this.previewMaxItems) {

            preview = selected.slice(0, this.previewMaxItems).map((e) => e.innerText).join(", ")
            preview += ", + "+(selected.length-this.previewMaxItems)+" ..."

            this.elPreview.classList.remove("multiselect-preview-empty")

        } else if (selected.length > 0) {

            preview = selected.map((e) => e.innerText).join(", ")

            this.elPreview.classList.remove("multiselect-preview-empty")

        } else {
            this.elPreview.classList.add("multiselect-preview-empty")
        }

        this.elPreview.innerText = preview;
    }

    toggleMenu() {
        if (this.elMenu.classList.contains('open')) {
            this.closeMenu();
        } else {
            this.openMenu();
        }
    }

    openMenu() {
        this.elMenu.classList.add('open');

        console.log(this.elSearch);

        if (this.elSearch) {
            this.elSearch.focus();
        }
    }

    closeMenu() {
        this.elMenu.classList.remove('open');
    }

}

// Close dropdowns
window.addEventListener('click', (e) => {
  const el = (e.target as Element);

  let thisMultiselect: Element|null = null;

  if (el.matches(".multiselect *")) {
    thisMultiselect = el.closest(".multiselect");
  }

  // Close all other multiselects
  const menus = document.querySelectorAll(".multiselect > .multiselect-menu.open");

  for (let i = 0; i < menus.length; i++) {
    const menu = menus[i];

    if (menu.closest(".multiselect") !== thisMultiselect) {
      menu.classList.remove("open");
    }
  }
})

export { Multiselect };
